import React, { useReducer, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import ModalDialog from '../../../Components/ModalDialog';
import { create } from '../../../Redux/Action/ClientAddressAction';
import Validator from '../../../Library/Validator/CreateAddressValidator';
import HelpDialog from '../../../Components/HelpDialog';
import KeyValueEditRow from '../../../Components/KeyValueEditRow';
import ShowHideContainer from '../../../Components/ShowHideContainer';
import { CLIENTTYPE_MONTEUR } from '../../../Library/Types';

const initialState = {
  type: 'storageaddress',
  name: '',
  zip: '',
  city: '',
  street: '',
  streetNo: '',
  contactName: '',
  contactPhone: '',
  comment: '',
  radius: 0,
};

function reducer(state, action) {
  switch (action.type) {
    case 'name':
      return { ...state, name: action.payload };
    case 'zip':
      return { ...state, zip: action.payload };
    case 'city':
      return { ...state, city: action.payload };
    case 'street':
      return { ...state, street: action.payload };
    case 'streetNo':
      return { ...state, streetNo: action.payload };
    case 'contactName':
      return { ...state, contactName: action.payload };
    case 'contactPhone':
      return { ...state, contactPhone: action.payload };
    case 'comment':
      return { ...state, comment: action.payload };
    case 'radius':
      return { ...state, radius: action.payload };
    case 'reset':
      return { ...initialState };

    default:
      throw new Error();
  }
}

/**
 * Add()
 * @param props
 * @returns {null|*}
 * @constructor
 */
function Add(props) {
  const {
    visible, onClose, onSaved, client,
  } = props;
  const [state, dispatch] = useReducer(reducer, initialState);
  const [errors, setErrors] = useState({});
  const [showHelp, setShowHelp] = useState(false);
  const [currentTabIndex, setCurrentTabIndex] = React.useState(null);

  const save = () => {
    const validator = new Validator();

    if (validator.isValid(state)) {
      // eslint-disable-next-line react/prop-types
      props.create(state).then(() => {
        onSaved();
        dispatch({ type: 'reset' });
      });
    } else {
      setErrors(validator.getMessages());
    }
  };

  const onCancel = () => {
    setErrors({});
    dispatch({ type: 'reset' });
    onClose();
  };

  return (
    <ModalDialog onClose={() => onCancel()} onConfirm={() => save()} visible={visible}>
      <div className="row">
        <div className="col-sm-12">
          <h5 className="hk-text-primary">
            Standort oder Lageradresse hinzufügen
          </h5>

          <hr />
          <div role="tablist">
            <KeyValueEditRow
              title="Name / Bezeichnung"
              initialValue={state.name}
              displayText={state.name}
              onChange={(value) => dispatch({ type: 'name', payload: value })}
              containerTabIndex={1}
              startEditMode={(currentTabIndex === 1)}
              onPressEnterGetNextTabIndex={setCurrentTabIndex}
              hasError={!!(errors.name)}
            />
            <div className="row">
              <div className="col-lg-8">
                <KeyValueEditRow
                  title="Strasse"
                  initialValue={state.street}
                  displayText={state.street}
                  onChange={(value) => dispatch({ type: 'street', payload: value })}
                  containerTabIndex={2}
                  startEditMode={(currentTabIndex === 2)}
                  onPressEnterGetNextTabIndex={setCurrentTabIndex}
                  hasError={!!(errors.street)}
                />
              </div>
              <div className="col-lg-4">
                <KeyValueEditRow
                  title="Hausnummer"
                  initialValue={state.streetNo}
                  displayText={state.streetNo}
                  onChange={(value) => dispatch({ type: 'streetNo', payload: value })}
                  containerTabIndex={3}
                  startEditMode={(currentTabIndex === 3)}
                  onPressEnterGetNextTabIndex={setCurrentTabIndex}
                  hasError={!!(errors.streetNo)}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-lg-4">
                <KeyValueEditRow
                  title="Postleitzahl"
                  initialValue={state.zip}
                  displayText={state.zip}
                  onChange={(value) => dispatch({ type: 'zip', payload: value })}
                  containerTabIndex={4}
                  startEditMode={(currentTabIndex === 4)}
                  onPressEnterGetNextTabIndex={setCurrentTabIndex}
                  hasError={!!(errors.zip)}
                />
              </div>
              <div className="col-lg-8">
                <KeyValueEditRow
                  title="Ort"
                  initialValue={state.city}
                  displayText={state.city}
                  onChange={(value) => dispatch({ type: 'city', payload: value })}
                  containerTabIndex={5}
                  startEditMode={(currentTabIndex === 5)}
                  onPressEnterGetNextTabIndex={setCurrentTabIndex}
                  hasError={!!(errors.city)}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-lg-6">
                <KeyValueEditRow
                  title="Kontakt Person"
                  initialValue={state.contactName}
                  displayText={state.contactName}
                  onChange={(value) => dispatch({ type: 'contactName', payload: value })}
                  containerTabIndex={6}
                  startEditMode={(currentTabIndex === 6)}
                  onPressEnterGetNextTabIndex={setCurrentTabIndex}
                  hasError={!!(errors.contactName)}
                />
              </div>
              <div className="col-lg-6">
                <KeyValueEditRow
                  title="Kontakt Telefon"
                  initialValue={state.contactPhone}
                  displayText={state.contactPhone}
                  onChange={(value) => dispatch({ type: 'contactPhone', payload: value })}
                  containerTabIndex={7}
                  startEditMode={(currentTabIndex === 7)}
                  onPressEnterGetNextTabIndex={setCurrentTabIndex}
                  hasError={!!(errors.contactPhone)}
                />
              </div>
            </div>

            <ShowHideContainer visible={client.type === CLIENTTYPE_MONTEUR}>
              <KeyValueEditRow
                title="Umkreissuche / Radius"
                initialValue={state.radius}
                displayText={state.radius}
                onChange={(value) => dispatch({ type: 'radius', payload: value })}
                containerTabIndex={8}
                startEditMode={(currentTabIndex === 8)}
                onPressEnterGetNextTabIndex={setCurrentTabIndex}
                hasError={!!(errors.radius)}
                onHelpAction={() => setShowHelp(true)}
                isNumeric
              />
            </ShowHideContainer>
            <KeyValueEditRow
              title="Kommentar"
              initialValue={state.comment}
              displayText={state.comment}
              onChange={(value) => dispatch({ type: 'comment', payload: value })}
              containerTabIndex={9}
              startEditMode={(currentTabIndex === 9)}
              onPressEnterGetNextTabIndex={setCurrentTabIndex}
              hasError={!!(errors.comment)}
            />
          </div>
        </div>
      </div>

      <HelpDialog context="addressRadius" visible={showHelp} onClose={() => setShowHelp(false)} />
    </ModalDialog>
  );
}

function mapStoreToProps(store) {
  return {
    isLoading: store.user.isLoggedin,
    client: store.auth.client,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    create: (addressData) => dispatch(create(addressData)),
  };
}

export default connect(mapStoreToProps, mapDispatchToProps)(withRouter(Add));

Add.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSaved: PropTypes.func.isRequired,
  client: PropTypes.instanceOf(Object).isRequired,
};
